module.exports = __webpack_public_path__ + "img/ts16.d3af284a.png";